<mat-toolbar class="primary" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px">
  <button (click)="back()" mat-icon-button>
    <mat-icon style="color: white;">
      keyboard_arrow_left
    </mat-icon>
  </button>
  <span style="color: white;">Filter</span>
</mat-toolbar>

<div fxLayout="row" fxFlexFill fxLayoutGap="15px">
  <div fxFlex="30" class="fx30">

    <div class="scrollY">
      <mat-nav-list class="chat-contacts">
        <ng-container *ngFor="let link of data.page | keyvalue " >

          <div [class.highlighted]="link.key==sss">

          
          <mat-list-item  (click)="subList(link.key)"   >
            <!-- <div fxLayoutAlign="space-between center">
            <p style="margin-bottom: 0px;" class="name">{{link.key}}</p>
            <mat-icon class="success"
            *ngIf="keyChecked.indexOf(link.key) >= 0">
           done</mat-icon>
          </div> -->
          <span   fxLayoutAlign="start center" fxLayoutGap="15px" class="login wordWarp">{{link.key}}&nbsp;&nbsp;
            <mat-icon class="primary-" *ngIf="keyChecked.indexOf(link.key) >= 0" class="material-icons-outlined f18">
              done
            </mat-icon>
          </span>
       
        </mat-list-item>
        </div>

        </ng-container>

     
       
        <ng-continer>
          
          <div [class.highlighted]="sss=='Price'">
          <mat-list-item  (click)="subList(key)" >
            <!-- <div   fxLayoutAlign="space-between center">
              <span style="margin-bottom: 0px;" class="name">Price</span>

              <mat-icon class="success" 
              *ngIf="keyChecked.indexOf('Price') >= 0">
             done</mat-icon>
            </div> -->
            <span   fxLayoutAlign="start center" fxLayoutGap="15px" class="login wordWarp">Price&nbsp;&nbsp;
              <mat-icon class="primary-icon" *ngIf="keyChecked.indexOf('Price') >= 0" class="material-icons-outlined f18">
                done
              </mat-icon>
            </span>
          </mat-list-item>
          </div>
        </ng-continer>
      
      </mat-nav-list>
    </div>
  </div>
  <div fxFlex="70">
    <ng-container *ngIf="sss!=key; else elseBlock">

    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-form-field fxFlex="100" floatLabel="never" fxFlex.gt-sm="50">
        <input matInput placeholder="Search For {{sss}}" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
      </mat-form-field>
    </div>
    <div class="scrollY">
      <div fxLayout="column" *ngFor="let size1 of data.page[this.sss]| filter:searchText:'size1';let i=index; ">
        <mat-checkbox [checked]="selection.indexOf(sss+size1) >= 0" (change)="filterColumn($event,size1,i,sss )" [value]="size1"
          color="primary">{{size1 |texttransform}}</mat-checkbox>
      </div>
    </div>
    </ng-container>
  </div>

  <ng-template #elseBlock>
    <div fxLayout="row" >
      <div class="scrollY">
        <div fxLayout="row" fxLayoutGap="10px">
       
        <mat-form-field fxFlex="100" appearance="legacy">
          <mat-label>Min</mat-label>

          <input    trim="blur"   name="new-label"  [autocomplete]="'off'"   [formControl]="minPriceControl" (input)="checkContains('minPriceControl')" (blur)="rangeChanged('minPriceControl')" matInput >
    
        </mat-form-field>
        </div>
      
        <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field  fxFlex="100"appearance="legacy">
          <mat-label>Max</mat-label>
          <input numbersOnly  trim="blur"   name="new-label"  [autocomplete]="'off'"   [formControl]="maxPriceControl"  (input)="checkContains('maxPriceControl')" (blur)="rangeChanged('maxPriceControl')" matInput >
    
        </mat-form-field>
      </div>
      </div>
    </div>
  </ng-template>
</div>

<footer class=" positionFix mat-elevation-z6 sticky1">
  <div fxLayout="row">
    <div fxFlex="50">
      <div  class="padding-t5 padding-l5">
        <div fxLayout="column" fxLayoutAlign="center start">
          <b> {{totalCount}}</b>
          <small>products Found</small>
        </div>
      </div>
    </div>
    <div fxFlex="50">
      <div (click)="apply()" class="faliure-bg padding-10" fxLayoutAlign="center end">
        <div class="icon_color" fxLayoutAlign="center center" matRipple>
          <span>APPLY</span>
        </div>
      </div>
    </div>
  </div>
</footer>